const cookieHref = '/about/privacy-policy/#cookie';
const sravniITinfoHref = 'https://f.sravni.ru/cms/file/filepath/information_about_it_activities_sravni.pdf';

export { cookieHref, sravniITinfoHref };
//# sourceMappingURL=links.js.map
